(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('instanceDao', ["http", "sqlQueries", "singleRowConverter", "defaultListConverter", function (http, sqlQueries, singleRowConverter, defaultListConverter) {
        return {
            retrieve: function (entityId) {
                return http.get(sqlQueries('entity/instance')).params({ entity_id: entityId }).converter(singleRowConverter);
            },
            users: function (columns, instanceId) {
                return http.get(sqlQueries('instance_users')).params({ instance_id: instanceId }).converter(defaultListConverter, { columns: columns });
            },
            groups: function (columns, instanceId) {
                return http.get(sqlQueries('instance_groups')).params({ instance_id: instanceId }).converter(defaultListConverter, { columns: columns });
            },
            volumes: function (columns, entityType) {
                return http.get(sqlQueries(entityType)).converter(defaultListConverter, { columns: columns });
            },
            vpcs: function (columns, instanceId, entityType) {
                return http.get(sqlQueries(entityType)).params({ instance_id: instanceId }).converter(defaultListConverter, { columns: columns });
            },
            iprules: function (columns, instanceId, entityType) {
                return http.get(sqlQueries(entityType)).params({ instance_id: instanceId }).converter(defaultListConverter, { columns: columns });
            },
            networkInterface: function (columns, instanceId, entityType) {
                return http.get(sqlQueries(entityType)).params({ instance_id: instanceId }).converter(defaultListConverter, { columns: columns });
            },
            tags: function (columns, instanceId, entityType) {
                return http.get(sqlQueries(entityType)).params({ instance_id: instanceId }).converter(defaultListConverter, { columns: columns });
            }
        };
    }]);
}());